/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarBodyTypeFromJSON, CarBodyTypeToJSON, CarPaintProtectionTypeFromJSON, CarPaintProtectionTypeToJSON, CarStatusFromJSON, CarStatusToJSON, DriveTypeFromJSON, DriveTypeToJSON, FuelTypeFromJSON, FuelTypeToJSON, GearTypeFromJSON, GearTypeToJSON, OrderedFileDtoFromJSON, OrderedFileDtoToJSON, PaintEffectTypeFromJSON, PaintEffectTypeToJSON, } from './';
export function CarDtoFromJSON(json) {
    return CarDtoFromJSONTyped(json, false);
}
export function CarDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'carModelId': !exists(json, 'carModelId') ? undefined : json['carModelId'],
        'carModelName': !exists(json, 'carModelName') ? undefined : json['carModelName'],
        'carMakeName': !exists(json, 'carMakeName') ? undefined : json['carMakeName'],
        'carMakeId': !exists(json, 'carMakeId') ? undefined : json['carMakeId'],
        'manufactureYear': !exists(json, 'manufactureYear') ? undefined : json['manufactureYear'],
        'plateNumber': !exists(json, 'plateNumber') ? undefined : json['plateNumber'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'calendarColorRGB': !exists(json, 'calendarColorRGB') ? undefined : json['calendarColorRGB'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'fuel': !exists(json, 'fuel') ? undefined : FuelTypeFromJSON(json['fuel']),
        'photos': !exists(json, 'photos') ? undefined : (json['photos'] === null ? null : json['photos'].map(OrderedFileDtoFromJSON)),
        'mainPhoto': !exists(json, 'mainPhoto') ? undefined : OrderedFileDtoFromJSON(json['mainPhoto']),
        'modelPhotos': !exists(json, 'modelPhotos') ? undefined : (json['modelPhotos'] === null ? null : json['modelPhotos'].map(OrderedFileDtoFromJSON)),
        'vin': !exists(json, 'vin') ? undefined : json['vin'],
        'engineOil': !exists(json, 'engineOil') ? undefined : json['engineOil'],
        'engineCapacity': !exists(json, 'engineCapacity') ? undefined : json['engineCapacity'],
        'maxSpeed': !exists(json, 'maxSpeed') ? undefined : json['maxSpeed'],
        'mass': !exists(json, 'mass') ? undefined : json['mass'],
        'currentMileage': !exists(json, 'currentMileage') ? undefined : json['currentMileage'],
        'acceleration': !exists(json, 'acceleration') ? undefined : json['acceleration'],
        'paintEffect': !exists(json, 'paintEffect') ? undefined : PaintEffectTypeFromJSON(json['paintEffect']),
        'drive': !exists(json, 'drive') ? undefined : DriveTypeFromJSON(json['drive']),
        'gear': !exists(json, 'gear') ? undefined : GearTypeFromJSON(json['gear']),
        'firstRegistration': !exists(json, 'firstRegistration') ? undefined : (json['firstRegistration'] === null ? null : new Date(json['firstRegistration'])),
        'currentWorth': !exists(json, 'currentWorth') ? undefined : json['currentWorth'],
        'bodyType': !exists(json, 'bodyType') ? undefined : CarBodyTypeFromJSON(json['bodyType']),
        'bodyColorId': !exists(json, 'bodyColorId') ? undefined : json['bodyColorId'],
        'bodyColorMakeCode': !exists(json, 'bodyColorMakeCode') ? undefined : json['bodyColorMakeCode'],
        'status': !exists(json, 'status') ? undefined : CarStatusFromJSON(json['status']),
        'paintProtection': !exists(json, 'paintProtection') ? undefined : CarPaintProtectionTypeFromJSON(json['paintProtection']),
        'remarks': !exists(json, 'remarks') ? undefined : json['remarks'],
        'garageSpotId': !exists(json, 'garageSpotId') ? undefined : json['garageSpotId'],
    };
}
export function CarDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carId': value.carId,
        'carModelId': value.carModelId,
        'carModelName': value.carModelName,
        'carMakeName': value.carMakeName,
        'carMakeId': value.carMakeId,
        'manufactureYear': value.manufactureYear,
        'plateNumber': value.plateNumber,
        'enginePower': value.enginePower,
        'calendarColorRGB': value.calendarColorRGB,
        'location': value.location,
        'fuel': FuelTypeToJSON(value.fuel),
        'photos': value.photos === undefined ? undefined : (value.photos === null ? null : value.photos.map(OrderedFileDtoToJSON)),
        'mainPhoto': OrderedFileDtoToJSON(value.mainPhoto),
        'modelPhotos': value.modelPhotos === undefined ? undefined : (value.modelPhotos === null ? null : value.modelPhotos.map(OrderedFileDtoToJSON)),
        'vin': value.vin,
        'engineOil': value.engineOil,
        'engineCapacity': value.engineCapacity,
        'maxSpeed': value.maxSpeed,
        'mass': value.mass,
        'currentMileage': value.currentMileage,
        'acceleration': value.acceleration,
        'paintEffect': PaintEffectTypeToJSON(value.paintEffect),
        'drive': DriveTypeToJSON(value.drive),
        'gear': GearTypeToJSON(value.gear),
        'firstRegistration': value.firstRegistration === undefined ? undefined : (value.firstRegistration === null ? null : value.firstRegistration.toISOString()),
        'currentWorth': value.currentWorth,
        'bodyType': CarBodyTypeToJSON(value.bodyType),
        'bodyColorId': value.bodyColorId,
        'bodyColorMakeCode': value.bodyColorMakeCode,
        'status': CarStatusToJSON(value.status),
        'paintProtection': CarPaintProtectionTypeToJSON(value.paintProtection),
        'remarks': value.remarks,
        'garageSpotId': value.garageSpotId,
    };
}
